import React from 'react';
import PropTypes from 'prop-types';

import styles from './Tags.m.sass';

export default class Tags extends React.PureComponent {
  render() {
    const {tags} = this.props;

    return(
      <div className={styles.tagList}>
        {tags.map(tag => (
          <span key={tag} className={styles.tagList_tag}>{tag}</span>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/tags/Tags.js